import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: 12,
    border: "1px solid",
    padding: theme.spacing(1.75, 2),
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  title: {
    fontSize: "0.95rem",
    fontWeight: 700,
    lineHeight: 1.3,
    margin: 0,
    "&.MuiTypography-root": {
      fontWeight: 700,
    },
  },
  description: {
    fontSize: "0.875rem",
    fontWeight: 400,
    color: "#5B5D66",
    lineHeight: 1.4,
    margin: 0,
  },
  error: {
    backgroundColor: "#FEECEC",
    borderColor: "#E5484D",
  },
  errorTitle: {
    color: "#B42318",
  },
  warning: {
    backgroundColor: "#FFF6E0",
    borderColor: "#E5A100",
  },
  warningTitle: {
    color: "#7A5300",
  },
}));

export default useStyles;
